export default {
  '请求': {
    '加载中': 'Caricamento',
    '请求失败': 'Richiesta non riuscita',
    '登录已过期': 'Sessione scaduta',
    '网络连接失败': 'Connessione di rete non riuscita',
    '请重新登录': 'Accedi di nuovo',
    '没有权限访问': 'Accesso negato',
    '请求的资源不存在': 'Risorsa non trovata',
    '服务器错误': 'Errore del server',
    '网络错误': 'Errore di rete',
    '刷新成功': 'Aggiornato',
    '获取中': 'Caricamento......',
    '账号下线': 'Account offline',
    '功能已禁用': 'Funzione disabilitata',
  },
  '导航': {
    '首页': 'Home',
    '选妃': 'Scegli',
    '认证': 'Verifica',
    '影院': 'Video',
    '个人': 'Mio',
  },
  '首页': {
    '注册': 'Registrati',
    '影片': 'Video',
    '女团': 'Ragazze',
    '热门城市': 'Città popolari:',
    '经理预订': 'Prenotazione manager',
    '看更多': 'Altro',
    '身份验证': 'Verificato',
    '身高': 'Altezza',
    '胸围': 'Petto',
    '服务城市': 'Città:',
  },
  '女团': {
    '女团': 'Ragazze',
    '选妃': 'Scegli',
    '身份验证': 'Verificato',
    '身高': 'Altezza',
    '胸围': 'Petto',
    '服务城市': 'Città:',
    '注册': 'Registrati',
    '请联系顾问或接待员': 'Contatta un consulente',
  },
  '登录': {
    '登录会员视窗': 'Accesso membro',
    '请输入用户名': 'Nome utente',
    '请输入密码': 'Password',
    '登录': 'Accedi',
    '没有账号马上注册': 'Nessun account? Registrati',
    '登录成功': 'Accesso riuscito',
    '登录注册': 'Accedi / Registrati',
    '登录可享受更多服务': 'Accedi per più servizi!',
  },
  '注册': {
    '注册': 'Registrati',
    '登录': 'Accedi',
    '请输入用户名': 'Nome utente',
    '用户名规则': '6-20 lettere/numeri',
    '请输入密码': 'Password',
    '密码规则': '6-16 lettere e numeri',
    '请输入验证码': 'Captcha',
    '验证码规则': 'Inserisci captcha a 4 cifre',
    '请输入邀请码': 'Codice invito',
    '邀请码规则': "Inserisci il codice invito dell'agente",
    '同意协议': 'Ho 18+ e accetto i Termini',
    '立即注册': 'Registrati ora',
    '注册中': 'Registrazione...',
    '已有账号马上登录': 'Hai già un account? Accedi',
    '注册成功': 'Registrato!',
    '注册失败': 'Registrazione non riuscita: ',
    '验证码错误': 'Captcha non valido',
    '请同意注册条款': 'Accetta i termini',
    '用户名已存在': 'Nome utente già esistente',
    '邀请码无效': 'Codice invito non valido',
  },
  '抢单': {
    '今日收益': 'Entrate di oggi',
    '余额': 'Saldo',
    '订单': 'Ordini',
    '开始抢单': 'Prendi ordine',
    '当前等级': 'Livello:',
    '提现': 'Preleva',
    '在线客服': 'Supporto',
    '充值': 'Ricarica',
    '幸运任务': 'Missione fortunata',
    '幸运订单': 'Ordine fortunato',
    '幸运订单提示': 'Congratulazioni! Ordine ad alta commissione',
    '恭喜获得幸运订单': 'Ordine fortunato ottenuto!',
    '提交订单': 'Invia ordine',
    '未完成订单提示': 'Hai un ordine non pagato. Paga prima.',
    '正在获取订单': "Caricamento dell'ordine...",
    '抢单时间': 'Ora presa:',
    '订单号': 'N. ordine',
    '订单总额': 'Totale',
    '佣金': 'Commissione',
    '商品单价': 'Prezzo',
    '预计收入': 'Guadagni stimati',
    '确认支付': 'Paga ora',
    '确认付款': 'Conferma pagamento',
    '支付处理中': 'Elaborazione...',
    '取消': 'Annulla',
    '去查看': 'Vedi',
    '暂无可用订单': 'Nessun ordine disponibile',
    '正在加载用户信息': 'Caricamento info utente...',
    '今日抢单已达上限': 'Limite giornaliero raggiunto',
    '余额不足无法获取订单': 'Saldo insufficiente',
    '获取订单失败': "Impossibile ottenere l'ordine",
    '支付成功': 'Pagamento riuscito',
    '支付失败': 'Pagamento non riuscito',
    '支付失败请重试': 'Pagamento non riuscito, riprova',
    '请完成任务单后进入': 'Completa prima le missioni',
    '请设置收款卡': 'Collega un indirizzo di prelievo',,
    '当前余额': 'Saldo attuale',
    '还需缴纳': 'Importo da versare',
  },
  '我的': {
    '我的页面': 'La mia pagina',
    '钻石': 'Diamante',
    '信誉分': 'Credito',
    '开通专属会员': 'Attiva VIP',
    '开启一次日期不限': 'Sblocco una tantum, senza limite di data',
    '提现': 'Preleva',
    '历史订单': 'Cronologia ordini',
    '充值记录': 'Cronologia ricariche',
    '提现记录': 'Cronologia prelievi',
    '添加钱包地址': 'Aggiungi indirizzo wallet',
    '邀请码': 'Codice invito:',
    '余额': 'Saldo',
    '退出登陆': 'Esci',
  },
  '会员': {
    '会员等级': 'Abbonamento:',
    '普通等级': 'Normale',
    '当前等级': 'Attuale',
    '立即开通': 'Attiva',
    '免费说明': '(Video gratuiti) (Matching gratuito)',
    '所需投资': 'Investimento richiesto',
    '佣金': 'Commissione',
    '订单': 'Ordini',
    '加入': 'Unisciti >>',
  },
  '充值': {
    '充值': 'Ricarica',
    '当前余额': 'Saldo',
    '余额': 'Saldo: ',
    '个': '',
    '充值金额': 'Importo',
    '请输入充值金额': "Inserisci l'importo",
    '快速选择金额': 'Importo rapido',
    '确认': 'Conferma',
    '提示': 'Suggerimento',
    '金额错误': 'Importo non valido',
    '立即充值': 'Ricarica ora',
    '提交成功': 'Inviato, in attesa di revisione',
  },
  '提现': {
    '提现': 'Preleva',
    '兑换积分': 'Preleva punti',
    '最大提款金额': 'Importo max',
    '资金密码': 'Password fondi',
    '余额': 'Saldo: ',
    '个': '',
    '钱包地址': 'Indirizzo wallet: ',
    '请选择提款地址': "Seleziona l'indirizzo di prelievo",
    '暂无绑定地址': 'Nessun indirizzo collegato',
    '提交': 'Invia',
    '通知': 'Avviso:',
    '单笔最大提现': '1. Max per prelievo: ',
    '单笔最低提现': '2. Min per prelievo: ',
    '检查姓名账号': '3. Controlla nome e conto',
    '注意提款费用': '4. Attenzione alle commissioni di prelievo',
    '请填写正确的金额': 'Inserisci un importo valido',
    '当前余额': 'Saldo',
    '提现金额': 'Importo',
    '请输入提现数量': "Inserisci l'importo",
    '立即提现': 'Preleva ora',
    '交易密码': 'Password di pagamento',
    '请输入交易密码': 'Inserisci la password di pagamento',
    '请先设置提现密码': 'Imposta prima la password di prelievo',
  },
  '绑卡': {
    '添加钱包地址': 'Aggiungi indirizzo wallet',
    '钱包地址信息': 'Info wallet',
    '请输入支付卡信息': 'Inserisci il tuo indirizzo wallet',
    '加密货币类型': 'Tipo di crypto',
    '请选择加密货币类型': 'Seleziona il tipo di crypto',
    '钱包地址': 'Indirizzo wallet',
    '请输入钱包地址': "Inserisci l'indirizzo wallet",
    '绑卡说明': 'Gentile utente, per la sicurezza dei fondi collega il tuo nome reale e imposta una password di prelievo. Il nome deve corrispondere al conto.',
    '确定绑卡': 'Conferma collegamento',
    '绑卡提示': 'Suggerimento: collega una banca importante. Contatta il supporto per modificare.',
    '请先设置姓名': 'Imposta prima il nome!',
    '已绑定不可修改': 'Indirizzo già collegato. Contatta il supporto per modificarlo.',
  },
  '订单历史': {
    '订单历史': 'Cronologia ordini',
    '数据为空': 'Nessun dato',
    '订单号': 'N. ordine: ',
    '已完成': 'Completato',
    '处理中': 'In elaborazione',
    '完成订单': 'Completa ordine',
    '订单金额': 'Importo: ',
    '佣金': 'Commissione: ',
    '创建时间': 'Creato: ',
    '上一页': 'Prec.',
    '下一页': 'Succ.',
    '获取失败': 'Caricamento cronologia non riuscito',
    '获取失败重试': 'Caricamento non riuscito, riprova',
    '未知': 'Sconosciuto',
    '完成成功': 'Ordine completato!',
    '完成失败': 'Completamento non riuscito: ',
    '完成失败重试': 'Completamento non riuscito, riprova',
    '请输入支付密码': 'Inserisci la password di pagamento',
    '请先设置支付密码': 'Imposta prima la password di pagamento',
  },
  '入金记录': {
    '标题': 'Cronologia ricariche',
    '数据为空': 'Nessun dato',
    '认证结果': 'Risultato',
    '下单积分': 'Punti: ',
    '下单时间': 'Ordinato: ',
    '结算时间': 'Liquidato: ',
    '待审核': 'In attesa',
    '已通过': 'Approvato',
    '已拒绝': 'Rifiutato',
    '暂无数据': 'Nessun dato',
  },
  '提现记录': {
    '标题': 'Cronologia prelievi',
    '数据为空': 'Nessun dato',
    '待审核': 'In attesa',
    '审核成功': 'Approvato',
    '审核退回': 'Rifiutato',
    '未知状态': 'Sconosciuto',
    '金额': 'Importo: ',
    '说明': 'Nota: ',
    '提交时间': 'Inviato: ',
    '审核时间': 'Revisionato: ',
    '已通过': 'Approvato',
    '已拒绝': 'Rifiutato',
    '暂无数据': 'Nessun dato',
  },
  '资料': {
    '基本信息': 'Profilo',
    '头像': 'Avatar',
    '姓名': 'Nome',
    '未设置': 'Non impostato',
    '性别': 'Sesso',
    '男': 'Maschio',
    '女': 'Femmina',
    '未知': 'Sconosciuto',
    '设定': 'Impostazioni',
    '账号信息': 'Account',
    '更改登录密码': 'Cambia password di accesso',
    '设定支付密码': 'Imposta password di pagamento',
    '退出登录': 'Esci',
    '设置': 'Impostazioni',
    '登录密码': 'Password di accesso',
    '资金密码': 'Password fondi',
    '提现密码已设置': 'Password di prelievo impostata. Contatta il supporto per modificarla.',
    '已设置': 'Impostato',
    '修改真实姓名': 'Modifica nome reale',
    '请输入真实姓名': 'Inserisci il nome reale',
    '真实姓名说明': 'Il nome reale deve corrispondere ai dati del wallet',
    '提交': 'Invia',
    '请勿重复设置': 'Già impostato!',
    '修改登录密码': 'Cambia password di accesso',
    '设置资金密码': 'Imposta password fondi',
    '保存': 'Salva',
    '旧密码': 'Vecchia password',
    '请输入旧密码': 'Inserisci la vecchia password',
    '新密码': 'Nuova password',
    '请输入新密码': 'Inserisci la nuova password',
    '确认密码': 'Conferma password',
    '请再次输入新密码': 'Inserisci di nuovo la nuova password',
    '请填写完整': 'Compila tutti i campi!',
    '两次密码不一致': 'Le password non corrispondono',
    '性别修改': 'Modifica sesso',
    '个人报表': 'Report personale',
    '任务金额积分': 'Importo missioni (punti)',
    '盈利公式': 'Profitto = Vincita − Importo missioni',
    '任务金额': 'Importo missioni',
    '充值金额': 'Ricarica',
    '金额': 'Importo',
    '中奖金额': 'Importo vinto',
    '个人情报': 'Profilo',
    '身高': 'Altezza:',
    '胸围': 'Petto:',
    '收费区间': 'Fascia di prezzo:',
    '系统公告': 'Annunci',
  },
  '客服': {
    '联系客服': 'Contatta il supporto',
    '在线客服': 'Supporto online',
    '暂无客服': 'Nessun supporto disponibile',
    '联系': 'Contatta',
    '服务时间': 'Al tuo servizio 24/7',
  },
  '影院': {
    '影院': 'Cinema',
    '全部': 'Tutti',
    '最高分': 'Più votati',
    '播放': 'Visualizzazioni: ',
    '次播放': ' visualizzazioni',
    '热门推荐': 'Popolari',
    '播放次数': 'Visualizzazioni:',
    '请充值后观看': 'Ricarica per guardare',
  },
  '语言切换器': {
    '切换语言': 'Lingua',
    '语言': 'Lingua',
  },
}
